import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useDeleteExternalAgent = () => {
  const {
    data: isDeleted,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const deleteExternalAgent = async (agentName: string) => {
    await call(`/admin/externalAgents/${agentName}`, "DELETE");
  };

  return {
    deleteExternalAgent,
    isDeleted,
    isLoading,
    isFailed,
  };
};
